<!--
 * @Description: 
 * @Author: juanjuanhui
 * @Date: 2023-08-01 17:51:15
 * @LastEditors: juanjuanhui
 * @LastEditTime: 2023-08-04 10:56:06
-->
<template>
  <div class="con-wrap">
    <List :accountType="accountType" />
  </div>
</template>

<script>
import List from "@/components/RegionAccount/List";
export default {
  name: "CountyManageList",
  components: { List },
  data() {
    return {
      accountType: "county",
    };
  },
};
</script>
<style lang="scss" scoped>
.con-wrap {
  overflow: auto;
}
</style>
